import config from '@astina/paloma-shop-portal-ui/src/services/PortalConfig';
import { createPortalUiApp } from "@astina/paloma-shop-portal-ui/src/init";
import VensoOrderGroupView from "@/views/VensoOrderGroupView.vue";
import VensoInvoiceRequestView from "@/views/VensoInvoiceRequestView.vue";
import VensoDeliveryView from "@/views/VensoDeliveryView.vue";
config.customRoutes = [
    {
        name: 'venso_order_group',
        path: '/supplier/group/:id',
        component: VensoOrderGroupView,
    },
    {
        name: 'venso_invoice_request',
        path: '/supplier/invoice/:id',
        component: VensoInvoiceRequestView,
    },
];
config.overrides.views.deliveries_delivery = VensoDeliveryView;
config.demand.showImages = true;
config.accessRequestsEnabled = false;
const app = createPortalUiApp();
app.mount('#app');
